var a = /* @__PURE__ */ ((r) => (r.FACE_ID = "face", r.PROX = "prox", r.PASSWORD = "pwd", r.IMPR_ID = "impr-id", r.IMPR_PIN = "impr-pin", r.IID_DISABLED = "impr-id-push-disabled", r))(a || {}), E = /* @__PURE__ */ ((r) => (r.KNOW = "know", r.HAVE = "have", r.ARE = "are", r))(E || {}), e = /* @__PURE__ */ ((r) => (r.ACCEPTED = "accepted", r.NOT_AVAILABLE = "not-available", r.PUSH_TIMEOUT = "push-timeout", r.REJECTED = "rejected", r))(e || {});
const f = {
  face: {
    factorType: "face",
    factorCategory: "are",
    pushable: !1
  },
  prox: {
    factorType: "prox",
    factorCategory: "have",
    pushable: !1
  },
  pwd: {
    factorType: "pwd",
    factorCategory: "know",
    pushable: !1
  },
  "impr-id": {
    factorType: "impr-id",
    factorCategory: "have",
    pushable: !0
  },
  "impr-pin": {
    factorType: "impr-pin",
    factorCategory: "have",
    pushable: !1
  }
};
var p = /* @__PURE__ */ ((r) => (r.GRANTED = "granted", r.DECLINED = "not-granted", r.EMPTY = "", r))(p || {}), D = /* @__PURE__ */ ((r) => (r.BIOMETRICS = "impr.biometrics", r))(D || {}), i = /* @__PURE__ */ ((r) => (r.CHECK_NEEDED = "CHECK_NEEDED", r.UPDATE_NEEDED = "UPDATE_NEEDED", r.NONE = "NONE", r))(i || {});
export {
  a as A,
  p as C,
  E as F,
  e as P,
  f as a,
  D as b,
  i as c
};
//# sourceMappingURL=api-DwyZ-w1t.js.map
